/**
 * @file paddle hack banner
 * @author wanzhongyun
 */

import React from 'react';
import { IHackBanner } from './../../type';

import './style.less';


const HackBanner: React.FC<IHackBanner> = props => {

    const {
        backgroundImageUrl,
        registerWord,
        registerLink,
        detail,
        detailLink
    } = props;
    
    return (
        <div className='paddle-hack-banner-wrapper'>
            <div className='paddle-hack-banner-content' style={{backgroundImage: `url(${backgroundImageUrl})`}}>
                {/* <img className='paddle-hack-banner-image' src={backgroundImageUrl} alt='' /> */}
                <div className='paddle-hack-banner-btn-wrapper'>
                    <a href={registerLink} target='_blank' rel='noreferrer'>
                        <div className='register-btn'>{registerWord}</div>
                    </a>
                    <a href={detailLink} target='_blank' rel='noreferrer'>
                        <div className='detail-btn'>{detail}</div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default HackBanner;